<template>
    <div class="news-files">
        <v-row v-if="files.length < 5">
            <v-col
                class="news-file-col"
                v-for="(file, index) in files"
                :key="index"
                cols="12"
                md="6"
            >
                <news-file
                    :name="file.name"
                    :href="file.href"
                />
            </v-col>
        </v-row>
        <ul
            v-else
            class="news-files-list"
        >
            <li
                v-for="(file, index) in files"
                :key="index"
            >
                <a
                    :href="file.href"
                    class="news-file"
                    target="_blank"
                >
                    {{ file.name }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import NewsFile from '@/components/news/NewsFile.vue'

export default {
    name: 'NewsFiles',
    components: { NewsFile },
    props: {
        files: Array
    },
    computed: {
        fileName(name) {
            let arr = name.split('/')
            return arr[arr.length - 1]
        },
        fileHref(name) {
            return window.document.location.origin + name
        }
    }
}
</script>
